import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject, Observable } from "rxjs/Rx";
import { AppConstant } from "src/app/app.constant";
import { map } from "rxjs/operators";
import { DataResult } from "@progress/kendo-data-query";

@Injectable()
export class SettingService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    public getAllSetting(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllSetting/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    updateSetting(setting) {
        return this.httpClient.post(`${this.apiUrl}/updateSetting`, setting).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
}